import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/markdoc/tags/index.ts'
import * as nodes from '/vercel/path0/markdoc/nodes/index.ts'
const functions = {};
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

const tokenizer = new Markdoc.Tokenizer();

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: CQT is Here!\ndate: 2021-06-22T04:25:15-05:00\ncategories: [\"ecosystem\"]\ndescription: The Covalent Query Token is now live!\nauthor: niall\nsubbrand_image: https://www.covalenthq.com/static/images/blog/202106/cqt.jpg\ntype: legacy\n---\n\n\nAfter months of persistent technical, legal, ecosystem, and governance foundational work, we're excited to share that the Covalent governance token — CQT (Covalent Query Token) is here. The CQT contract address is **0xD417144312DbF50465b1C641d016962017Ef6240**. Please be extremely vigilant. Several scams are circulating amongst groups on Telegram and Discord.\n\n\n\n## What is Covalent?\n\nCovalent is a unified API bringing visibility to billions of blockchain data points.\n\n\n{% youtube videoId=\"blIj-W_Qb1Q\" /%}\n\n\nSince our humble beginnings in 2017, we have been singularly focused on our mission, bringing transparency and visibility to blockchain networks. After having reached product-market fit, onboarding 200+ customers across 12 blockchains, a roster of grade A private sale participants, a 30-person stellar team, we're now ready to execute on the next evolution of Covalent. Our mission has grown in importance more so than ever in the history of blockchain networks. Today, there are billions of dollars secured by blockchain networks, and Covalent's mission is crucial for the large-scale fulfillment of the decentralization promise. With our decentralized network, we are embarking on this shared journey together.\n\n## Where is CQT Being Traded?\n\nCQT can be found on both Centralized and Decentralized Exchanges.\n\n**Centralized Exchanges**\n\n- [FTX](https://ftx.com/en)\n- [OKEx](https://www.okex.com/)\n- [Gate.io](https://www.gate.io/)\n\n**Decentralized Exhanges**\n\n- [SushiSwap](https://app.sushi.com/): 0x17890DeB188F2dE6C3e966e053dA1C9a111Ed4A5\n\n## Have the Covalent Smart Contracts been Audited?\n\nYes, both by Certik and QuantStamp.\n\n- [View the Certik Report.](https://www.covalenthq.com/static/audits/certik-cqt-audit-report.pdf)\n- [View the QuantStamp Report.](https://www.covalenthq.com/static/audits/quantstamp-cqt-audit-report.pdf)\n\n## Where can I read more about CQT token economics**?**\n\nYou can read more about the token economics on the Covalent CQT page ([https://www.covalenthq.com/token/](https://www.covalenthq.com/token/)).\n\n## FAQ\n\nA comprehensive FAQ regarding CQT can be found [here](https://www.notion.so/covalenthq/CQT-FAQ-52cb9d289a6b48269e496c76010b9687).\n\n\n\n\n";
const filepath = "/blog/cqt-live.md";
const tokens = tokenizer.tokenize(source);
const ast = Markdoc.parse(tokens);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    const tokens = tokenizer.tokenize(partials[key]);
    partials[key] = Markdoc.parse(tokens);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
